import { use } from 'react';
import { I18nContext } from '../contexts/I18nContext';

/**
 * Custom hook to use the i18n context using React 19 use() hook
 *
 * @returns I18nContextValue with current language, supported languages, and functions
 * @throws Error if used outside of I18nProvider
 */
export const useI18n = () => {
  const context = use(I18nContext);
  if (!context) {
    throw new Error('useI18n must be used within an I18nProvider');
  }
  return context;
};